import { Schema } from "rsuite";

const { Model, Types } = Schema;

export type ForgetPasswordFormType = {
  userId?: string;
};

export const ForgetPasswordFormSchema = Model({
  userId: Types.StringType().isRequired(),
});

export const ForgetPasswordDefaultValues: ForgetPasswordFormType = {
  userId: "",
};
